import AppClient from "../utils/http-client/app-client"
import { ApiResponse } from "../utils/type/api-response.type"
import { CardholderPrivilegeResponseBody } from "../utils/type/statement-service.type"

export const getCardholderPrivilege =
  (): ApiResponse<CardholderPrivilegeResponseBody> => {
    return AppClient.get(`/api/v1/info`)
  }

export const fetchMinioContent = (filePath: string): ApiResponse<string> => {
  return AppClient.get(`/api/v1/minio`, {
    params: {
      FilePath: filePath,
    },
  })
}

export const fetchMinioImgContent = (filePath: string): ApiResponse<string> => {
  return AppClient.get(`/api/v1/minio/img`, {
    params: {
      FilePath: filePath,
    },
  })
}

export default getCardholderPrivilege
